import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import { ErrorLlamada } from "../../components/Modals";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";
import ClientService from "services/clientService";

function IntenteLuego() {
  const navigate = useNavigate();
  const location = useLocation();
  const clientService = new ClientService();

  const idLead = location.state?.idLead || location.state?.transaction?.idLead;

  const modal = {
    open: true,
    showX: true,
    content: (
      <ErrorLlamada
        showBtn={!!idLead}
        handleClickBtn={() => handleCallMe(idLead)}
      />
    ),
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  const handleCallMe = async (id) => {
    const payload = {
      ...location.state?.transaction,
      idLead: id,
    };
    const response = await clientService.getCallMe(payload);
    if (response.code === 200) {
      navigate(`${URLs.graciasSiisa}`);
    }
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.intenteLuego}
      noImage={true}
    />
  );
}

export default IntenteLuego;
